import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {SaleSummaryModel} from '../saleSummary.model';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PartnerSummaryConverter} from '../../../../partner/common/api/converter/partnerSummary.converter';
import {PaymentRequestSummaryConverter} from '../../../modules/payment_request/api/entity/converter/paymentRequestSummary.converter';
import {DateConverter} from '../../../../common/converter/date.converter';
import {Injectable} from '@angular/core';
import {OfficeSummaryConverter} from "../../../../office/api/model/converter/officeSummary.converter";

@Injectable({providedIn: 'root'})
export class SaleSummaryConverter extends HttpModelConverter<SaleSummaryModel> {


    constructor(private lovValueConverter: LovValueSummaryConverter,
                private partnerConverter: PartnerSummaryConverter,
                private dateConverter: DateConverter,
                private paymentRequestSummaryConverter: PaymentRequestSummaryConverter,
                private officeSummaryConverter: OfficeSummaryConverter) {
        super();
    }

    protected createInstance(): SaleSummaryModel {
        return new SaleSummaryModel();
    }

    protected enrichObject(result: SaleSummaryModel, src: SaleSummaryModel) {
        result.date = this.dateConverter.convert(src.date);
        result.createdAt = this.dateConverter.convert(src.createdAt);
        result.updatedAt = this.dateConverter.convert(src.updatedAt);
        result.direction = this.lovValueConverter.convert(src.direction);
        result.partner = this.partnerConverter.convert(src.partner);
        result.status = this.lovValueConverter.convert(src.status);
        result.office = this.officeSummaryConverter.convert(src.office);
        result.paymentRequests = this.paymentRequestSummaryConverter.convertFromArray(src.paymentRequests);
    }


}
